// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#main[data-v-d0318b5a] {\r\n    width: 100%;\r\n    height: 350px;\r\n    float: left;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center; /* 垂直居中 */\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center; /* 水平居中 */\n}\r\n\r\n/* #main >>> div canvas{\r\n  height:350px !important;\r\n} */\r\n", ""]);
// Exports
module.exports = exports;
